export default __webpack_public_path__ + "static/media/Registre-des-activites-de-traitement.3efe2fa4.xls";